import './i18n/config';
import { ReactNode } from 'react';
import { ScreenClassProvider } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import { AuthContextProvider } from './auth';
import { stylesheet } from './global.module.scss';
import { sanitiseLocale } from './i18n/config';
import { DefaultPageTrackingParams, DefaultPageTrackingParamsContext } from './utils/analytics';
import { EnvironmentContext } from './utils/environmentContext';
import type { Locale } from './i18n/config';
import type { EnvironmentContextType } from './utils/environmentContext';

interface AppProps {
    defaultPageTrackingParams: DefaultPageTrackingParams;
    locale: Locale;
    envContext: EnvironmentContextType;
    children: ReactNode;
}

export const App = ({ defaultPageTrackingParams, locale, envContext, children }: AppProps) => {
    useStyles(stylesheet);

    return (
        <AuthContextProvider locale={sanitiseLocale(locale)}>
            <ScreenClassProvider>
                <DefaultPageTrackingParamsContext.Provider value={defaultPageTrackingParams}>
                    <EnvironmentContext.Provider value={envContext}>
                        {children}
                    </EnvironmentContext.Provider>
                </DefaultPageTrackingParamsContext.Provider>
            </ScreenClassProvider>
        </AuthContextProvider>
    );
};
